import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "dashboard__navbar" }
const _hoisted_3 = { class: "dashboard__content-container" }
const _hoisted_4 = { class: "dashboard__content" }

import Notifications from "@/components/layout/Notifications.vue";
import Navbar from "@/components/navigation/Navbar.vue";
import {onMounted, ref} from "vue";
import {useMemberStore} from "@/stores/memberStore";
import {useMemberService} from "@/inversify.config";
import LogoutPopup from "@/components/layout/LogoutPopup.vue";
import Loader from "@/components/layout/Loader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const memberStore = useMemberStore()
const memberService = useMemberService()

const memberIsLoading = ref(true)

onMounted(async () => {
  memberIsLoading.value = true
  let member = await memberService.getCurrentMember()
  if (member)
    memberStore.setMember(member)
  memberIsLoading.value = false
});


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LogoutPopup),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Navbar, { "member-is-loading": memberIsLoading.value }, null, 8, ["member-is-loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Notifications),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterView, null, {
          default: _withCtx(({Component}) => [
            Component
              ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
                  fallback: _withCtx(() => [
                    _createVNode(Loader)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})